<!-- 查看/编辑过敏源弹窗 -->
<template>
    <div>
        <el-dialog title="查看详情" :visible.sync="isShowCheck" top="100px" width="30%" custom-class="custom-dialog-class"
            @close="closeDialog">
            <div class="dialog-container">
                <el-form label-width="120px" :rules="rules">
                    <el-form-item label="类型名称：" prop="typeName">
                        <span>{{ contentObj.typeName }}</span>
                    </el-form-item>
                    <el-form-item label="食材：" prop="material">
                        <span>{{ contentObj.foodName?.join('、') || '' }}</span>
                    </el-form-item>
                </el-form>
            </div>
            <template #footer>
                <slot></slot>
            </template>
        </el-dialog>
        <EditDialog :isOpen.sync="isShowEdit" :toggleOpen="closeDialog"
            :row="{ ...contentObj, foodName: JSON.parse(contentObj.foodObjList) }" @reEditCommit="reEditCommit"
            operType="reEdit" proTitle="重新提交">
            <template v-slot:default="slotProps">
                <el-button type="primary" @click="slotProps.submitForm">重新提交</el-button>
                <el-button @click="closeDialog">取 消</el-button>
            </template>
        </EditDialog>
    </div>
</template>
<script>
import { post } from "@/api/http";
import EditDialog from "../AvoidFoodManager/EditDialog.vue"
export default {
    name: "AvoidFoodDialog",
    components: { EditDialog },
    props: {
        operType: {
            type: String,
            default: "check",
        },
        content: {
            type: String,
            default: "",
        },
        rowId: {
            type: String,
            default: "",
        },
        closeDialog: {
            type: Function,
            default: () => { },
        },
    },
    data() {
        return {
            contentObj: JSON.parse(this.content || "{}"),
            rules: {
                material: [
                    { required: true, message: "", trigger: "change" },
                ],
            },
        };
    },
    computed: {
        isShowCheck() {
            return this.operType === "check";
        },
        isShowEdit() {
            return this.operType === "edit";
        },
    },
    methods: {
        // 重新提交
        async reEditCommit(content = {}) {
            try {
                const params = {
                    id: this.rowId,
                    content: JSON.stringify(content)
                }
                const result = await post("/diet/audit/reSubmit", params);
                const { code } = result;
                if (code === "SUCCESS") {
                    this.$message.success("提交成功");
                    this.closeDialog(); // 关闭弹窗
                    this.$emit('fetchTableList');
                } else {
                    this.$message.error("提交失败，请重试！");
                }
            } catch (error) {
                console.log(error);
            }
        }
    },
};
</script>
<style lang="scss" scoped>
.itemContainer {
    display: flex;
    gap: 10px;

    .item {
        background-color: rgb(203, 226, 255);
        color: rgba(26, 124, 242);
        border-radius: 50px;
        padding: 0 8px;
        min-width: 60px;
        text-align: center;
    }
}
</style>
